const ShowHeroSwiper = () => {
  document.addEventListener("DOMContentLoaded", () => {
    const showSwiperEl = document.querySelector('.show-hero swiper-container');
    if (!showSwiperEl) return;

    const params = {
      injectStyles: [`
        .swiper-pagination-bullet {
          width: 20px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          font-size: 12px;
          color: #000;
          opacity: 1;
          background: rgba(0, 0, 0, 0.2);
        }
        .swiper-pagination-bullet-active {
          color: #fff;
          background: #007aff;
        }
      `],
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"></span>';
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    };

    Object.assign(showSwiperEl, params);
    showSwiperEl.initialize();

    // Load YouTube API once
    const loadYouTubeAPI = () => {
      return new Promise((resolve) => {
        if (window.YT && window.YT.Player) {
          resolve();
        } else {
          const script = document.createElement('script');
          script.src = "https://www.youtube.com/iframe_api";
          script.onload = () => {
            const checkYT = setInterval(() => {
              if (window.YT && window.YT.Player) {
                clearInterval(checkYT);
                resolve();
              }
            }, 100);
          };
          document.body.appendChild(script);
        }
      });
    };

    // Initialize YouTube videos on slides that have a video id
    const initYouTubeVideos = () => {
      const slides = document.querySelectorAll('swiper-slide');
      slides.forEach((slide) => {
        const videoId = slide.getAttribute('data-video-id');
        const splitVideoId = videoId?.split('https://youtu.be/')[1];
        const cleanVideoId = splitVideoId?.replace(/['"]+/g, '');
        if (cleanVideoId) {
          document.querySelector('.show-image-carousel').classList.add('video-carousel');
          const videoWrapper = slide.querySelector('.slide-video-container');
          if (videoWrapper) {
            const videoContainer = document.createElement('div');
            videoContainer.className = 'video-container';
            videoContainer.id = `youtube-player-${cleanVideoId}`;

            // Hide the fallback image
            const img = slide.querySelector('img');
            if (img) {
              img.style.display = 'none';
            }
            videoWrapper.appendChild(videoContainer);

            // Initialize YouTube Player
            new YT.Player(videoContainer.id, {
              videoId: cleanVideoId,
              playerVars: {
                autoplay: false,
                mute: 1,
                loop: 1,
                playlist: cleanVideoId, // Required for looping
                controls: 1,
                modestbranding: 1,
                rel: 0,
                showinfo: 0,
                iv_load_policy: 3,
                disablekb: 1,
              }
            });
          }
        }
      });
    };

    loadYouTubeAPI().then(() => {
      if (window.YT && window.YT.Player) {
        initYouTubeVideos();
      }
    });
  });
};

export default ShowHeroSwiper;
